import React from 'react';
type Tone = 'sand' | 'sage' | 'light';
interface ChipsProps {
  items: string[];
  tone?: Tone;
}
const tones: Record<Tone, string> = {
  sand: 'bg-brand-sand/25 text-brand-charcoal border-brand-sand/60',
  sage: 'bg-brand-sage/10 text-brand-sage border-brand-sage/30',
  light: 'bg-white/10 text-white border-white/25'
};
export function Chips({
  items,
  tone = 'sand'
}: ChipsProps) {
  return <ul className="flex flex-wrap gap-1.5" data-id="element-64" data-mp="12rzyt6st0v61">
      {items.map(item => <li key={item} className={`rounded border px-2 py-1 text-[11px] font-semibold leading-tight sm:text-xs ${tones[tone]}`} data-id="element-65" data-mp="17j8ak9hlwsmd">
          {item}
        </li>)}
    </ul>;
}